module.exports = __webpack_public_path__ + "img/img42.d6e194e5.svg";